import { createSlice } from '@reduxjs/toolkit';
import LocalStorageService from '../services/localstorage.service';

const initialState = {
    isComponentOnCall: false,
    isCallIncomming: false,
    isCallAttended: false, //for buttons
    callDetails: null,
    isCallEnded: false,
    conferenceData: LocalStorageService.getObject("conferenceData") !== null ? LocalStorageService.getObject("conferenceData") : [],
    transferData: LocalStorageService.getObject("transferData") !== null ? LocalStorageService.getObject("transferData") : [],
    alwaysOnCallConnectedDetails: { alwaysOnCallConnected: false, alwaysOnCallUcid: "" },
    callControlsActions: { isCallOnMute: false, isCallOnHold: false, isCallRecording: true, isDialSelected: false, isTransferSelected: false, isConferenceSelected: false },
    isCallActivityPresent: false,
    transferActiveTab: '',
    transferCommentsByTab: { Skill: '', Agent: '', Phone: '', IVR: '' },
    screenPopURL: null,
    isCallBackCallNotAttended: {
        cbState: false,
        cbId: null,
        cbNumber: null
    },
    isCurrentLocationAndrescheduleDateTime: {
        currentLocationTime: null,
        rescheduleDateTime: null
    },
    IVRcheckpointsData: null,
    campaignScript: {
        isOpen: false
    },
    wrapUpTimeExceeded: false,
    hasNextNumber: false,
    previewPropsRedex: null,
    previewCampaignsRedex: [],
    click2Call: null,
    pauseAfterCallStatus: false,
    pauseAfterCallReason: null,
    pauseToggleStatus: false,
    callChatQueueInfo: [],
    transcribe: {
    },
    previewRetryCountdown: null
};

export const callSlice = createSlice({
    name: 'call',
    initialState,
    reducers: {
        setIsComponentOnCall: (state, action) => {
            state.isComponentOnCall = action.payload;
            state.isCallActivityPresent = (action.payload || state.isCallEnded || state.isCallIncomming)
        },
        setIsCallIncomming: (state, action) => {
            state.isCallIncomming = action.payload
            state.isCallActivityPresent = (action.payload || state.isCallEnded || state.isComponentOnCall)
        },
        setCallDetails: (state, action) => {
            state.callDetails = action.payload
        },
        setIsCallEnded: (state, action) => {
            state.isCallEnded = action.payload
            state.isCallActivityPresent = (action.payload || state.isCallIncomming || state.isComponentOnCall)
        },
        setIsCallAttended: (state, action) => {
            state.isCallAttended = action.payload
        },
        removeConferenceNumber: (state, action) => {
            state.conferenceData = action.payload;
        },
        addConferenceNumber: (state, action) => {
            state.conferenceData.push(action.payload)
        },
        handleConferenceHoldState: (state, action) => {
            state.conferenceData = action.payload
        },
        removeTransferNumber: (state, action) => {
            state.transferData = action.payload;
        },
        addTransferNumber: (state, action) => {
            state.transferData.push(action.payload)
        },
        handleTransferHoldState: (state, action) => {
            state.transferData = action.payload
        },
        setCallControlsActions: (state, action) => {
            if (typeof action.payload === "object") {
                state.callControlsActions = { ...state.callControlsActions, ...action.payload };
            }
            else {
                state.callControlsActions = initialState.callControlsActions;
            }
        },
        callEndActions: (state, action) => {
            const itemsToBeClearedAfterCallEnd = ["CallEndTime", "callData", "conferenceData", "transferData"];
            itemsToBeClearedAfterCallEnd.forEach((item) => LocalStorageService.removeItem(item));
            state.isCallEnded = initialState.isCallEnded;
            state.callControlsActions = initialState.callControlsActions;
            state.transferData = [];
            state.conferenceData = [];
            state.callDetails = {};
            state.customerInformationApiData = initialState.customerInformationApiData;
            state.isCallActivityPresent = false;
            state.click2Call = null;
        },
        setAlwaysOnCallConnected: (state, action) => {
            state.alwaysOnCallConnectedDetails = action.payload;
        },
        setTransferActiveTab: (state, action) => {
            state.transferActiveTab = action.payload;
        },
        setTransferCommentForTab: (state, action) => {
            const { tab, comment } = action.payload;
            state.transferCommentsByTab[tab] = comment;
        },
        clearTransferComments: (state) => {
            state.transferCommentsByTab = { Skill: '', Agent: '', Phone: '', IVR: '' };
        },
        setIsCallBackCallNotAttended: (state, action) => {
            state.isCallBackCallNotAttended = action.payload
        },
        setCurrentLocationTimeAndRescheduleTime: (state, action) => {
            state.isCurrentLocationAndrescheduleDateTime = action.payload
        },
        resetCallSlice: (state, action) => {
            return initialState;
        },
        setIVRcheckpointData: (state, action) => {
            state.IVRcheckpointsData = action.payload
        },
        toggleCampaignScript: (state, action) => {
            state.campaignScript.isOpen = action.payload
        },
        setScreenpopURL: (state, action) => {
            state.screenPopURL = action.payload
        },
        setWrapUpTimeExceeded: (state, action) => {
            state.wrapUpTimeExceeded = action.payload
        },
        setHasNextNumber: (state, action) => {
            state.hasNextNumber = action.payload;
        },
        setPreviewPropsRedex: (state, action) => {
            state.previewPropsRedex = action.payload;
        },
        setPreviewCampaignsRedex: (state, action) => {
            state.previewCampaignsRedex = action.payload;
        },
        setClick2Call: (state, action) => {
            state.click2Call = action.payload
        },
        pauseAfterCall: (state, action) => {
            if (action.payload.type) {
                state.pauseAfterCallStatus = action.payload.type
            }
            else {
                state.pauseAfterCallStatus = false
            }
            if (action.payload.reason) {
                state.pauseAfterCallReason = action.payload.reason
            } else {
                state.pauseAfterCallReason = null
            }
        },
        pauseToggle: (state, action) => {
            state.pauseToggleStatus = action.payload
        },
        updateTranscribe: (state, action) => {
            const { key, value, timeStamp, channel, aiResponse } = action.payload;
            if (!state.transcribe[key]) {
                state.transcribe[key] = [];
            }
            state.transcribe[key].push({ value, timeStamp, channel, aiResponse });
        },

        removeTranscribeByKey: (state, action) => {
            const { key } = action.payload;
            if (state.transcribe[key]) {
                delete state.transcribe[key];
            }
            state.transcribe = { ...state.transcribe };
        },

        addAIResponse: (state, action) => {
            const { ucid, messageIndex, aiResponse } = action.payload;
            if (state.transcribe[ucid] && state.transcribe[ucid][messageIndex]) {
                state.transcribe[ucid][messageIndex] = {
                    ...state.transcribe[ucid][messageIndex],
                    aiResponse
                };
            }
        },
        setCallChatQueueDetails: (state, action) => {
            state.callChatQueueInfo = action.payload
        },
        setPreviewRetryCountdown: (state, action) => {
            state.previewRetryCountdown = action.payload
        },
    }
})

export const { setCallChatQueueDetails, removeTranscribeByKey, addAIResponse, updateTranscribe, pauseToggle, pauseAfterCall, setPreviewCampaignsRedex, setPreviewPropsRedex, setHasNextNumber, setWrapUpTimeExceeded, setScreenpopURL, setIVRcheckpointData, setTransferActiveTab, setTransferCommentForTab, clearTransferComments, setOpenCallsMinimized, setPreviewCallEnable, setIsComponentOnCall, setIsCallIncomming, setCallDetails, setIsCallEnded, setIsCallAttended, addConferenceNumber, removeConferenceNumber,
    setCallControlsActions, removeTransferNumber, setAlwaysOnCallConnected, addTransferNumber, handleConferenceHoldState, handleTransferHoldState, callEndActions, setIsCallBackCallNotAttended, setCurrentLocationTimeAndRescheduleTime, resetCallSlice, toggleCampaignScript, setClick2Call, setPreviewRetryCountdown
} = callSlice.actions;
export default callSlice.reducer;
